<template>
  <v-card>
    <v-card-text>
      <h1 class="headline">About</h1>

      <p>
        The GeoConverter provides an interface for the direct communication with web map services to order the map
        as well as a library to transform the images to the popular and comprehensive GeoTIFF graphics file format.<br>
        It reads and writes several GIS vector file formats based on the famous OGR tools and converts them.
      </p>

      <p>
        GeoConverter has been developed by the Geometa Lab at the OST Eastern Switzerland University of Applied Sciences Rapperswil.
        The Geometa Lab team can be reached via email: <a href="mailto:geometalab@ost.ch">geometalab@ost.ch</a>.
      </p>

      <img height="64" src="../assets/img/logos/OST-Logo_DE.png" alt="Ostschweizer Fachhochschule (OST) Logo">

      <address>
        Geometa Lab ℅ Prof. Stefan Keller<br>
        Institute for Software<br>
        OST Eastern Switzerland University of Applied Sciences<br>
        Oberseestrasse 10<br>
        CH-8640 Rapperswil (Switzerland)<br><br>
      </address>

      <h2 class="title">Acknowledgements</h2>

      <v-card>
        <v-list two-line subheader>
          <v-subheader>
            This project was supported by
          </v-subheader>
          <v-list-tile href="https://www.stadt-zuerich.ch/geoz" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/Logo_Stadt_Zurich_Geomatik_Vermessung.jpg" alt="Stadt Zürich Geomatik Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Stadt Zürich, GIS_Zentrum</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile href="http://www.geoportal.zh.ch" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/baudirektion-kanton-zuerich.jpg" alt="Stadt Zürich Baudirektion Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Kanton Zürich, Geoinformation</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>

      <h2 class="title">Built with</h2>

      <v-card>
        <v-list two-line>
          <v-list-tile href="https://vuejs.org/" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/img/logos/vue-logo.png" alt="Vuejs Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Vue.js</v-list-tile-title>
              <v-list-tile-sub-title>Vuejs Javascript Framework</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile href="https://www.python.org" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/img/logos/python-logo.png" alt="Python Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Python</v-list-tile-title>
              <v-list-tile-sub-title>Python Programming language</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile href="https://djangoproject.com" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/img/logos/django-logo.png" alt="Django Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>Django</v-list-tile-title>
              <v-list-tile-sub-title>Django Web Framework</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile href="http://gdal.org/" target="_blank" avatar>
            <v-list-tile-avatar>
              <img src="../assets/img/logos/gdal-logo.png" alt="GDAL Logo">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>GDAL/OGR</v-list-tile-title>
              <v-list-tile-sub-title>GDAL/OGR Geo-Information processing library</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>

      <v-spacer>
      </v-spacer>

      <queue-stats
        :small="false"
      ></queue-stats>

    </v-card-text>
  </v-card>
</template>

<script>
  import QueueStats from '@/components/QueueStats';

  export default {
    name: 'about',
    components: {
      'queue-stats': QueueStats,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/About.vue